/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const candidateEventResponseActorTypeSchema = z.enum(['recruiter', 'candidate', 'system'])

export type CandidateEventResponseActorTypeSchema = z.infer<typeof candidateEventResponseActorTypeSchema>
